/**
 * Retourne vrai s'il faut afficher le résumé du voyage.
 */
export default function bookingEstimateHasResume({ bookingEstimate }) {
  return Boolean(bookingEstimate);
}
